
export var environment = {
  // 上传路径
  upLoadPath() {
    return `${process.env.VUE_APP_BASE_URL}/service-admin/admin/file/upload`
    // return `http://manager.test.520wanda.com/api/service-admin/admin/file/upload`// 测试服
    // return `http://manager.voice.520wanda.com/api/service-admin/admin/file/upload`// voice
    // return `https://mgr.mugua.zhongboyq.com/api/service-admin/admin/file/upload`// 正式服
    // return `https://gw.xy.748seo.com/api/service-admin/admin/file/upload`// 雪月
  },
  // 富文本路径
  richTextPath() {
    // return `${process.env.VUE_APP_BASE_URL}/service-admin/admin/file/ueditor/upload`
    // return `http://manager.test.520wanda.com/api/service-admin/admin/file/ueditor/upload`// 测试服
    // return `http://manager.voice.520wanda.com/api/service-admin/admin/file/ueditor/upload`// voice
    return `https://mgr.mugua.zhongboyq.com/api/service-admin/admin/file/ueditor/upload`// 正式服
    // return `https://gw.xy.748seo.com/api/service-admin/admin/file/ueditor/upload`// 雪月
  },
  // 图片验证码
  verification() {
    const api = `${process.env.VUE_APP_BASE_URL}/service-admin/captcha/index`
    // const api = `http://manager.test.520wanda.com/api/service-admin/captcha/index`// 测试服
    // const api = `http://manager.voice.520wanda.com/api/service-admin/captcha/index`// voice
    // const api = `https://mgr.mugua.zhongboyq.com/api/service-admin/captcha/index`// 正式服
    // const api = `https://gw.xy.748seo.com/api/service-admin/captcha/index`// 雪月
    return api
  }
}
export default environment
//
